module.exports = __webpack_public_path__ + "img/logo_unilever.eb958241.png";